//Здесь, т.к. создаёт циклические ссылки
export var BoilerAdapterProtocol;
(function (BoilerAdapterProtocol) {
    BoilerAdapterProtocol[BoilerAdapterProtocol["OPENTHERM"] = 0] = "OPENTHERM";
    BoilerAdapterProtocol[BoilerAdapterProtocol["EBUS"] = 1] = "EBUS";
    BoilerAdapterProtocol[BoilerAdapterProtocol["NAVIEN"] = 2] = "NAVIEN";
    BoilerAdapterProtocol[BoilerAdapterProtocol["BSB"] = 3] = "BSB";
    BoilerAdapterProtocol[BoilerAdapterProtocol["AUTO"] = 4] = "AUTO";
    BoilerAdapterProtocol[BoilerAdapterProtocol["DAESUNG_CLASS_E"] = 5] = "DAESUNG_CLASS_E";
    BoilerAdapterProtocol[BoilerAdapterProtocol["DAESUNG_CLASS_A"] = 6] = "DAESUNG_CLASS_A";
    BoilerAdapterProtocol[BoilerAdapterProtocol["RINNAI_BR_R"] = 7] = "RINNAI_BR_R";
    BoilerAdapterProtocol[BoilerAdapterProtocol["ARDERIA"] = 8] = "ARDERIA";
    BoilerAdapterProtocol[BoilerAdapterProtocol["EMS_PLUS"] = 9] = "EMS_PLUS";
    BoilerAdapterProtocol[BoilerAdapterProtocol["DAESUNG_CLASS_A_MAX_50_PROT"] = 10] = "DAESUNG_CLASS_A_MAX_50_PROT";
    BoilerAdapterProtocol[BoilerAdapterProtocol["RINNAI_BR_K"] = 11] = "RINNAI_BR_K";
    BoilerAdapterProtocol[BoilerAdapterProtocol["MODBUS_IRBIS"] = 12] = "MODBUS_IRBIS";
    BoilerAdapterProtocol[BoilerAdapterProtocol["MODBUS_LEMAX"] = 16] = "MODBUS_LEMAX";
    BoilerAdapterProtocol[BoilerAdapterProtocol["RINNAI_BR_U"] = 17] = "RINNAI_BR_U";
    BoilerAdapterProtocol[BoilerAdapterProtocol["MODBUS_ROSSEN"] = 18] = "MODBUS_ROSSEN";
    BoilerAdapterProtocol[BoilerAdapterProtocol["KITURAMI"] = 20] = "KITURAMI";
})(BoilerAdapterProtocol || (BoilerAdapterProtocol = {}));
const translationBoilerAdapterProtocol = {
    [BoilerAdapterProtocol.OPENTHERM]: 'OpenTherm',
    [BoilerAdapterProtocol.EBUS]: 'E-Bus',
    [BoilerAdapterProtocol.NAVIEN]: 'NaviEN',
    [BoilerAdapterProtocol.BSB]: 'BSB',
    [BoilerAdapterProtocol.AUTO]: 'Auto',
    [BoilerAdapterProtocol.DAESUNG_CLASS_E]: 'Daesung Class E',
    [BoilerAdapterProtocol.DAESUNG_CLASS_A]: 'Daesung Class A',
    [BoilerAdapterProtocol.RINNAI_BR_R]: 'Rinnai BR-R',
    [BoilerAdapterProtocol.RINNAI_BR_K]: 'Rinnai BR-K',
    [BoilerAdapterProtocol.RINNAI_BR_U]: 'Rinnai BR-U',
    [BoilerAdapterProtocol.ARDERIA]: 'Arderia',
    [BoilerAdapterProtocol.EMS_PLUS]: 'EMS+',
    [BoilerAdapterProtocol.DAESUNG_CLASS_A_MAX_50_PROT]: 'Daesung Class A Max 50',
    [BoilerAdapterProtocol.MODBUS_IRBIS]: 'Modbus IRBIS',
    [BoilerAdapterProtocol.MODBUS_LEMAX]: 'Modbus LEMAX',
    [BoilerAdapterProtocol.MODBUS_ROSSEN]: 'Modbus ROSSEN',
    [BoilerAdapterProtocol.KITURAMI]: 'Kiturami',
};
export function translateBoilerAdapterProtocol(protocol) {
    return translationBoilerAdapterProtocol[protocol] ?? `Неизвестный: ${protocol}`;
}
